module.exports = __webpack_public_path__ + "static/media/Upload Image.820bbf9f.png";